export default __webpack_public_path__ + "static/media/crypto3.ed417fe8.png";